module.exports = __webpack_public_path__ + "img/cognitive_bg.f333159d.jpg";